import * as React from 'react';
import {
  DigitalMarketingBreadcrumb,
  DigitalMarketingBreadcrumbItem,
} from 'features/DigitalMarketing/components/DigitalMarketingBreadcrumb';
import { DMDiv, DMText } from './Primitives';

interface DashboardHeaderProps {
  title?: string;
  description?: string;
  breadcrumb?: Array<string | DigitalMarketingBreadcrumbItem>;
}

export const DashboardHeader = ({
  title = 'Digital Marketing Dashboard',
  description = "From Reach to Revenue, One Smart Dashboard to Accelerate Your Institution's Growth.",
  breadcrumb = [],
}: DashboardHeaderProps) => {
  const breadcrumbItems = breadcrumb.map(item =>
    typeof item === 'string' ? { label: item } : item
  );

  return (
    <DMDiv className="mb-[0.8vh]">
      <DigitalMarketingBreadcrumb
        className="mb-[1.5vh] text-[1.4vh]"
        includeBaseItems={false}
        items={breadcrumbItems}
      />
      <DMDiv as="header" className="flex items-start justify-between">
        <DMDiv>
          <DMText
            as="h1"
            className="text-[2.8vh] font-bold text-gray-900 leading-tight"
          >
            {title}
          </DMText>
          <DMText className="text-gray-500 text-[1.6vh] mt-[0.8vh] leading-tight">
            {description}
          </DMText>
        </DMDiv>
      </DMDiv>
    </DMDiv>
  );
};
